<template>
  <AuthForm :sub-title="$t('dashboard.auth.login.subTitle')" :title="$t('dashboard.auth.login.title')">
    <div slot="form" slot-scope="{ inputErrors, onSubmit }">
      <FormulateForm v-model="form" :errors="inputErrors" :schema="schema" @submit="() => onSubmit(submit)" />
      <div class="text-center">
        <div>
          <small class="text-muted text-center">
            {{ $t('dashboard.term.accountYet') }}
            <router-link to="/auth/register">{{ $t('dashboard.term.signUp') }}</router-link>
          </small>
        </div>
        <div>
          <small class="text-muted text-center">
            <router-link to="/auth/password_reset">
              {{ $t('dashboard.term.forgotPassword') }}
            </router-link>
          </small>
        </div>
      </div>
    </div>
  </AuthForm>
</template>

<script>
import { computed, onMounted, ref } from '@vue/composition-api'
import stringify from 'fast-json-stable-stringify'
import { useI18n, useRouter } from '@/app/core/lib/util'
import AuthService from '@/app/dashboard/services/auth-service'
import UserService from '@/app/dashboard/services/user-service'
import { Auth } from '@/app/shared/auth/auth'
import { AuthToken } from '@/app/shared/auth/auth-token'

const AuthForm = () => import('@/app/dashboard/components/auth/auth-form')

export default {
  name: 'login',
  components: { AuthForm },
  beforeRouteEnter(to, from, next) {
    if (Auth.isLoggedIn()) {
      next({ name: 'dashboard-project-list' })
    } else {
      next()
    }
  },
  setup() {
    const { t } = useI18n()
    const schema = computed(() => {
      return [
        {
          type: 'email',
          name: 'email',
          placeholder: 'name@address.com',
          label: t('dashboard.term.emailAddress'),
          validation: 'required|email'
        },
        {
          type: 'password',
          name: 'password',
          placeholder: 'Enter your password',
          label: t('dashboard.term.password'),
          validation: 'required'
        },
        {
          type: 'submit',
          label: t('dashboard.term.signIn')
        }
      ]
    })

    const form = ref(null)

    const { router } = useRouter()
    const submit = async () => {
      const token = await AuthService.createToken(form.value)
      AuthToken.set(token.auth_token, true)

      const user = await UserService.me()
      localStorage.setItem('user', stringify(user))

      // const workspaces = await WorkspaceService.list()
      // if (workspaces.count > 0) {
      //   if (WorkspaceToken.get()) {
      //     router.push({ name: 'project-list' })
      //   } else {
      //     router.push({ name: 'workspaces' })
      //   }
      // } else {
      //   router.push({ name: 'workspace-create' })
      // }

      router.push({ name: 'dashboard-project-list' })
    }

    onMounted(() => {
      AuthToken.set('', true)
    })

    return {
      schema,
      form,
      submit
    }
  }
}
</script>
